import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import divider from "@/components/common/divider";
import VueRouter from "vue-router"
import axios from 'axios'
import firebase from "firebase/app";
import 'firebase/analytics';

const baseUrl = 'http://goverment-support.dorbom.com/v1/';

Vue.config.productionTip = false;
Vue.use(divider);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.baseURL = baseUrl;

const firebaseConfig = {
    apiKey: "AIzaSyAXALPPaZLPE4o0RXXf0SdYdIRNZ0E3s3k",
    authDomain: "dorbomcorona.firebaseapp.com",
    databaseURL: "https://dorbomcorona.firebaseio.com",
    projectId: "dorbomcorona",
    storageBucket: "dorbomcorona.appspot.com",
    messagingSenderId: "1067453683148",
    appId: "1:1067453683148:web:908bc0e5e4647033013969",
    measurementId: "G-GMS4LXT2Y1"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const routes = [
    {
        path: '/', component: () => import("@/components/main/InformationMain.vue")
    },
    {
        path: '/detail/:sidx', name: 'detail', component: () => import("@/components/main/InformationDetail.vue")
    }
];

const router = new VueRouter({
    routes,
    scrollBehavior (to, from) {
        from

        if(from.path === "/") {
            return {x: 0, y: 0};
        }
    }
});

new Vue({
    render: h => h(App),
    router
}).$mount('#app');
